import {
  getInstituteName,
  getUserInstituteId,
  useInstitute,
} from "../../../../hooks/use-institute";

const InstitutePhotos = ({ user }) => {
  const { data: institute } = useInstitute(getUserInstituteId(user));
  const photos = [institute?.institutePhotos, institute?.photos, institute?.images]
    .flatMap((items) => (Array.isArray(items) ? items : []))
    .map((photo) => ({
      url: typeof photo === "string" ? photo : photo?.url || photo?.imageUrl,
      caption: typeof photo === "object" ? photo?.caption : "",
    }))
    .filter((photo) => typeof photo.url === "string" && photo.url.trim());

  if (!photos.length) return null;

  const instituteName = getInstituteName(institute) || "Institute";

  return (
    <section className="mt-4 w-full min-w-0 max-w-full overflow-hidden rounded-2xl p-2" aria-label={`${instituteName} Gallary`}>
      <h2 className="mb-3 text-left text-base font-bold text-[#34163F]">
        {instituteName} Gallary
      </h2>
      <div className="hide-scrollbar flex w-full flex-nowrap snap-x snap-mandatory gap-3 overflow-x-auto pb-2">
        {photos.map((photo, index) => (
          <a
            key={`${photo.url}-${index}`}
            href={photo.url}
            target="_blank"
            rel="noopener noreferrer"
            className="w-[85%] shrink-0 snap-start overflow-hidden rounded-xl bg-gray-50 sm:w-[48%]"
            aria-label={`View ${instituteName} photo ${index + 1}`}
          >
            <img
              src={photo.url}
              alt={photo.caption || `${instituteName} photo ${index + 1}`}
              loading="lazy"
              className="h-48 w-full object-cover sm:h-56"
            />
          </a>
        ))}
      </div>
    </section>
  );
};

export default InstitutePhotos;
